<div class="print-layout">
  <router-outlet></router-outlet>
</div>
